import {SxType} from '@baseTypes/sx/sxTypes'

export default {
	title: {
		fontSize: '18px',
		fontWeight: 700,
		mb: 1.5,
	},
	grid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, 180px)',
		gap: '10px',
	},
	card: {
		borderRadius: '10px',
		border: '1px solid',
		borderColor: 'divider',
		padding: '10px',
		cursor: 'pointer',
		textAlign: 'left',
		display: 'block',
		width: '180px',
		transition: 'border-color .2s, box-shadow .2s',
		'.lightTheme &': {
			backgroundColor: '#fff',
		},
		'.darkTheme &': {
			backgroundColor: 'rgba(255, 255, 255, 0.04)',
		},
		'&:hover': {
			borderColor: 'var(--account-accent, #0C6DDF)',
			boxShadow: '0 4px 14px rgba(0, 0, 0, 0.08)',
		},
	},
	head: {
		display: 'flex',
		alignItems: 'baseline',
		justifyContent: 'space-between',
		gap: '6px',
	},
	number: {
		fontSize: '14px',
		fontWeight: 700,
	},
	badge: {
		fontSize: '10px',
		fontWeight: 700,
		borderRadius: '999px',
		padding: '1px 7px',
		whiteSpace: 'nowrap',
		color: 'var(--account-accent-text, #0C6DDF)',
		backgroundColor: 'var(--account-accent-soft, rgba(12, 109, 223, 0.1))',
	},
	muted: {
		fontSize: '11px',
		color: 'text.secondary',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	circleLabel: {
		fontSize: '10px',
		color: 'text.secondary',
		mt: '6px',
	},
	stats: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '6px',
		mt: '6px',
		fontSize: '11px',
		color: 'text.secondary',
	},
	statValue: {
		fontSize: '13px',
		fontWeight: 700,
		color: 'text.primary',
		mr: '3px',
	},
	vypusky: {
		mt: '8px',
		pt: '6px',
		borderTop: '1px solid',
		borderColor: 'divider',
	},
	chips: {
		display: 'grid',
		gridTemplateColumns: 'repeat(5, 1fr)',
		gap: '4px',
		mt: '6px',
	},
	chip: {
		height: '24px',
		borderRadius: '5px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '11px',
		fontWeight: 700,
	},
	note: {
		fontSize: '13px',
		color: 'text.secondary',
		mb: 1,
	},
} as const satisfies SxType
